import styled, { css } from 'styled-components';
import BaseRating from 'react-rating';

export const StyledBaseRating = styled(BaseRating)`
  flex: 0 0 auto;

  ${(props) =>
    props.alignRight &&
    css`
      align-self: flex-end;

      @media (max-width: 577px) {
        align-self: flex-start;
      }
    `}
`;

export const RatingStar = styled.div`
  :before {
    content: '\f005';
    width: ${(props) => props.size || '10'}px;
    height: ${(props) => props.size || '10'}px;
    font-size: ${(props) => (props.size ? props.size * 2 : '16')}px;
    font-family: FontAwesome;
    color: ${(props) => props.color};
  }
`;
